import {mapState, mapActions} from 'vuex'

export const layoutComputed = {
    ...mapState('layout', {
        layoutType: (state) => state.layoutType,
        layoutScrollable: (state) => state.layoutScrollable,
        layoutMode: (state) => state.layoutMode,
        leftSidebarType: (state) => state.leftSidebarType,
        sidebarColor: (state) => state.sidebarColor,
        layoutWidth: (state) => state.layoutWidth,
        topbar: (state) => state.topbar
    })
}


export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutMode', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeSidebarColor', 'changeLayoutPosition'])


export const todoComputed = {
    ...mapState('todo', {
        todos: (state) => state.todos
    })
}
export const todoMethods = mapActions('todo', ['fetchTodos'])

export const authComputed = {
    ...mapState('auth', {
        accessToken: (state) => state.accessToken,
        refreshToken: (state) => state.refreshToken,
        account: (state) => state.account,
        userName: (state) => state.userName,
        isAuth: (state) => state.isAuth,
        scopes: (state) => state.scopes,
        roles: (state) => state.roles,
        expiration: (state) => state.expiration,
    })
}


export const authMethods = mapActions('auth', ['changeAccessToken', 'changeOrganizationCode', 'changeSystemCode', 'changeRefreshToken', 'changeAccount', 'changeUserName', 'changeIsAuth', 'changeScope', 'changeRole',
    'logout', 'changeExpiration', 'login'])